import { IModifier } from './Modifier';
import { EAnimationModifiers } from '../../Animation/SpineWrapperEventManager';
import { getAllEventModifiers } from '../../Utils/ModifierUtils';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { GameStore } from '@GameStore/GameStore';
import { ESpecialGamesType } from '@GFTypes/SpecialGames';

export class LockAndRollModifier implements IModifier {
    constructor(readonly gameStore: GameStore) {}

    public modifierCheck(name: string): boolean {
        return getAllEventModifiers(name).includes(EAnimationModifiers.LOCK_AND_ROLL);
    }

    public requirementCheck(name: string): boolean {
        const isLockAndRollMode = name.includes('SPECIAL_GAMES_INTRO')
            ? this.gameStore.get(EGameStoreKeys.CurrentSpecialGamesType) === ESpecialGamesType.LOCK_AND_ROLL
            : this.gameStore.get(EGameStoreKeys.IsLockAndRollMode);
        return isLockAndRollMode;
    }
}
